import script from "./TwoFASettings.vue?vue&type=script&setup=true&lang=js"
export * from "./TwoFASettings.vue?vue&type=script&setup=true&lang=js"

import "./TwoFASettings.vue?vue&type=style&index=0&id=5962ee25&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5962ee25"]])

export default __exports__